import { freeGiftSelect } from "@/api/cart";
import { queryGiftDetail } from "@/api/gift";
import { queryProductDetailApi } from "@/api/send-gift";
import Track from "@/utils/track";
import useNavigation from "@/utils/useNavigate";
import { FreeGiftPromoActivityModel, GiftProductModel } from "@akc/biz-api";
import { TrackDataContext } from "@akc/mx-taro-h5-components";
import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { Toast } from "antd-mobile";

export const useRgModal = () => {
  const { navigate2H5 } = useNavigation();
  const page_name = "赠品活动详情页";

  const track = Track();
  const [search] = useSearchParams();
  const { setTrackData } = useContext(TrackDataContext) as { setTrackData: (data: any) => void };

  const previous_page_name = search.get("page_name");

  const [selectType, setSelectType] = useState<string>("giftCard"); // giftCard卡片组件，giftCardGroup弹窗卡片组件
  const [promoActivityId, setPromoActivityId] = useState<string>(""); // 当前操作的活动
  const [popupVisible, setPopupVisible] = useState(false);
  const [freeGiftPromoActivityList, setFreeGiftPromoActivityList] = useState<
    FreeGiftPromoActivityModel[]
  >([]);
  const [freeGiftPromoActivity, setFreeGiftPromoActivity] = useState<FreeGiftPromoActivityModel>(
    {},
  );

  // Sku Modal related states and functions
  const [visible, setVisible] = useState(false);
  const [productDetail, setProductDetail] = useState<any>({});
  const [selectSkuId, setSelectSkuId] = useState<string | null | undefined>();
  const [skuText, setSkuText] = useState<string | null | undefined>("");
  const [actRuleDescUrl, setActRuleDescUrl] = useState<string>("");
  const [actRuleDescOpen, setActRuleDescOpen] = useState<boolean>(false);

  const getTrackData = (opts = {}) => {
    const { promoActivityId: activity_id } = freeGiftPromoActivity;
    return {
      page_name,
      btn_name: "关闭",
      previous_page_name,
      resource_type: "赠品选择规格弹窗",
      resource_name: "赠品选择规格弹窗",
      activity_id,
      ...(opts || {}),
    };
  };

  const handleShowModal = () => setVisible(true);
  const handleCloseModal = () => {
    track.track("resource_click", getTrackData());
    setVisible(false);
  };
  /**
   * 查询规则页地址
   * @param {string} acdId - 任意满赠活动ID（规则地址事实上跟满赠活动无强关联，只是借用了查活动详情的接口）
   */
  const queryGiftRulePageUrl = async (gift = freeGiftPromoActivity) => {
    try {
      const { promoActivityId } = gift;
      if (!promoActivityId) {
        return;
      }
      const res = (await queryGiftDetail(promoActivityId)) || {};
      setActRuleDescUrl(res?.actRuleDescUrl || "");
      setActRuleDescOpen(res?.actRuleDescOpen || false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    document.title = page_name;
    setTrackData({
      page_name,
    });
    track.track("$pageview", {
      page_name,
      previous_page_name,
    });
    try {
      const freeGiftPromotionInfoStr = localStorage.getItem("freeGiftPromotionInfo");
      const freeGiftPromotionInfo = freeGiftPromotionInfoStr
        ? JSON.parse(freeGiftPromotionInfoStr)
        : {};
      console.log("freeGiftPromotionInfo", freeGiftPromotionInfo);
      setFreeGiftPromoActivityList(freeGiftPromotionInfo?.freeGiftPromoActivityList || []);
    } catch (err) {
      setFreeGiftPromoActivityList([]);
    }
  }, []);

  const onFreeGiftSelect = props => {
    console.log(props);
    const { promoActivityId, promoRuleId, giftProductList } = props;
    freeGiftSelect({
      promoActivityId,
      promoRuleId,
      selectProductList: giftProductList
        .filter(e => e.isSelected)
        .map(({ spuId, skuId }) => ({
          spuId,
          skuId,
        })),
    });
  };

  const handleConfirmModal = props => {
    console.log("handleConfirmModal", props);
    const { skuId, firstSalePropertyValue, secondSalePropertyValue, productExt } = props;
    const { picList } = productExt;
    const { activitySpuId } = productDetail;

    const productPropertyDesc = secondSalePropertyValue
      ? `${firstSalePropertyValue}；${secondSalePropertyValue}`
      : firstSalePropertyValue;

    track.track(
      "resource_click",
      getTrackData({
        btn_name: "确认更换",
        activity_spu_code: activitySpuId,
        sku_id: skuId,
      }),
    );

    if (selectType === "giftCardGroup" && freeGiftPromoActivity.giftProductList?.length) {
      const updatedGiftList: GiftProductModel[] = [];
      const { giftProductList, optionalQuantity = 0, giftSwitchType = "1" } = freeGiftPromoActivity;
      const selectedGifts = giftProductList?.filter(g => g.isSelected) || [];
      for (let i = 0; i < giftProductList.length; i++) {
        const e = giftProductList[i];
        if (e.spuId === activitySpuId) {
          if (productExt?.skuQuantity < (e?.quantity || 0)) {
            return Toast.show({
              content: "商品库存不足",
              maskStyle: { zIndex: 100001 },
            });
          } else {
            const updatedGift = { ...e, skuId, productPropertyDesc };
            if (picList && picList[0]) {
              updatedGift.imageUrl = picList[0];
            }
            // 确认多规格没满就勾选
            if (selectedGifts.length < optionalQuantity) {
              updatedGift.isSelected = true;
            }
            updatedGiftList[i] = updatedGift;
          }
        } else {
          updatedGiftList[i] = e;
        }
      }

      setFreeGiftPromoActivity(prev => ({
        ...prev,
        giftProductList: updatedGiftList,
      }));
    } else if (selectType === "giftCard") {
      // 列表只有一个，直接多规格弹窗
      const updatedGiftList = freeGiftPromoActivityList.map((item: any) => {
        if (item?.promoActivityId === promoActivityId) {
          const { giftProductList = [] } = item;
          for (let i = 0; i < giftProductList?.length; i++) {
            const e = giftProductList[i];
            if (e.spuId === activitySpuId) {
              if (productExt?.skuQuantity < (e?.quantity || 0)) {
                Toast.show({
                  content: "商品库存不足",
                  maskStyle: { zIndex: 100001 },
                });
              } else {
                e.isSelected = true;
                e.skuId = skuId;
                e.productPropertyDesc = productPropertyDesc;
                if (picList && picList[0]) {
                  e.imageUrl = picList[0];
                }
                item.giftProductList[i] = e;
              }
            }
          }
          onFreeGiftSelect(item);
        }
        return item;
      });
      setFreeGiftPromoActivityList([...updatedGiftList]);
    }
  };

  const onConfirm = () => {
    const {
      giftProductList = [],
      promoActivityId,
      promoRuleId,
      giftSwitchType,
      canSelectedProductQuantity = 0,
      optionalQuantity = 0,
    } = freeGiftPromoActivity;
    // canSelectedProductQuantity >= optionalQuantity 要选择到 optionalQuantity
    // 否则要选择到 canSelectedProductQuantity
    if (giftSwitchType !== "1") {
      const selectList = giftProductList.filter(e => e.isSelected);
      const max =
        canSelectedProductQuantity >= optionalQuantity
          ? optionalQuantity
          : canSelectedProductQuantity;
      if (selectList.length < max) {
        return Toast.show({ content: `请最少选择${max}个赠品`, maskStyle: { zIndex: 100001 } });
      }
    }

    const selectProductList: { spuId: string; skuId: string }[] = [];
    for (let i = 0; i < giftProductList.length; i++) {
      const { isSelected, spuId = "", skuId = "" } = giftProductList[i];
      if (isSelected || giftSwitchType === "1") {
        if (!skuId) {
          return Toast.show({ content: "请完善规格选择", maskStyle: { zIndex: 100001 } });
        }
        selectProductList.push({
          spuId,
          skuId,
        });
      }
      if (giftSwitchType === "1") {
        giftProductList[i].isSelected = true;
      }
    }
    const updatedGiftList = freeGiftPromoActivityList.map(e => {
      if (e.promoActivityId === promoActivityId) {
        return freeGiftPromoActivity;
      }
      return e;
    });

    track.track(
      "resource_click",
      getTrackData({
        btn_name: "确认更换",
      }),
    );

    freeGiftSelect({
      promoActivityId,
      promoRuleId,
      selectProductList,
    }).then(res => {
      setFreeGiftPromoActivityList(updatedGiftList);
      setPopupVisible(false);
    });
  };

  // 获取商品详情
  const getProdInfo = async props => {
    const { product, selectType = "giftCard", promoActivityId } = props;

    if (!product) {
      return;
    }
    const { activityId, spuId: activitySpuId, skuId: selectSkuId, quantity: giftCount } = product;
    const productDetail = await queryProductDetailApi({
      activityId,
      activitySpuId,
      selectSkuId,
      pageId: "H5_ProductDetail",
    });
    setProductDetail({ ...productDetail, activityId, activitySpuId, giftCount });
    setSelectType(selectType);
    setPromoActivityId(promoActivityId);
    handleShowModal();
  };

  const onHandleGroupAction = (props: any) => {
    console.log("onHandleGroupAction", props);
    const { action, freeGift, item } = props;
    const { giftProductList, optionalQuantity } = freeGift;
    if (action === "attr") {
      getProdInfo({
        product: item,
        selectType: "giftCardGroup",
        promoActivityId: freeGift?.promoActivityId,
      });
    } else if (action === "select") {
      const selectedGifts =
        freeGiftPromoActivity.giftProductList?.filter(gift => gift.isSelected) || [];
      const hasReachedLimit = selectedGifts.length >= optionalQuantity;

      freeGiftPromoActivity.giftProductList = freeGiftPromoActivity.giftProductList?.map(gift => {
        if (optionalQuantity === 1) {
          gift.isSelected = gift.spuId === item.spuId;
        } else {
          if (gift.spuId === item.spuId) {
            const isDeselecting = gift.isSelected;
            if (isDeselecting || !hasReachedLimit) {
              gift.isSelected = !gift.isSelected;
            } else {
              Toast.show({
                content: `最多可选${optionalQuantity}件`,
                maskStyle: { zIndex: 100001 },
              });
            }
          }
        }
        return gift;
      });

      setFreeGiftPromoActivity({ ...freeGiftPromoActivity });
    }
  };

  const onHandleAction = (res: any) => {
    console.log("onHandleAction", res);
    const { freeGift, action, item } = res;
    if (["change", "choose"].includes(action)) {
      const gift = { ...freeGift };
      setFreeGiftPromoActivity(gift);
      setPopupVisible(true);
      queryGiftRulePageUrl(gift);
    } else if (action === "attr") {
      getProdInfo({
        product: item,
        selectType: "giftCard",
        promoActivityId: freeGift?.promoActivityId,
      });
    }
  };

  function getCount(type: string) {
    const { giftProductList = [], optionalQuantity = 0 } = freeGiftPromoActivity;
    if (type === "isSelected") {
      return giftProductList?.filter(e => e.isSelected)?.length;
    }
    return optionalQuantity;
  }

  // 点击规则说明按钮
  const onRule = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    navigate2H5("/#/user-protocol", {
      query: `docUrl=${actRuleDescUrl}`,
    });
  };

  return {
    onRule,
    getCount,
    onHandleAction,
    onHandleGroupAction,
    onConfirm,
    popupVisible,
    freeGiftPromoActivityList,
    freeGiftPromoActivity,
    setPopupVisible,
    setFreeGiftPromoActivityList,
    setFreeGiftPromoActivity,
    // Sku Modal related returns
    visible,
    productDetail,
    selectSkuId,
    skuText,
    handleConfirmModal,
    handleShowModal,
    handleCloseModal,
    getProdInfo,
    page_name,
    arrowRight:
      "https://akim-oss.aikucun.com/0b8888f4f8fdf638b5f93a35d7a7f2ace6099a31_1743490051286_96.png",
    closeIcon:
      "https://akim-oss.aikucun.com/9e13abec1676cfde392d4f9d6bb9c52c1fbe5a22_1743489652158_68.png",
    actRuleDescUrl,
    actRuleDescOpen,
  };
};
